module.exports = __webpack_public_path__ + "img/cafe_international-md.f16ebc2f.webp";